<ng-ut-origin-batch-weigh
  *ngIf="(store$ | async) as store"
  [userInfo]="store.userInfo"
  [origins]="store.state.origins"
  [originsLoading]="store.state.originsLoading"
  [loading]="store.state.loading"
  [source]="store.state.coalDensity?.coalDensitySource"
  [coalDensity]="store.state.coalDensity?.coalDensity"
  (searchOrigins)="searchOrigins($event)"
  (searchCoalDensity)="searchCoalDensity($event)"
  (submitReport)="submitReport($event)"
>
</ng-ut-origin-batch-weigh>
